const API_CONFIG = {
    /* ****** WEB API ******** */
    BASE_URL: 'https://api.canhbaolu.bache.vn/api/',
    /* ****** GET FILE URL ******** */
    URL_GET_FILE: 'https://api.canhbaolu.bache.vn/api/files',
    /* ****** GET PNG URL ******** */
    URL_GET_GEOJSON: 'https://api.canhbaolu.bache.vn/api/geojson',

    // Authen API
    auth: {
        login: 'user-login',
        verifyCode: 'user-login-request',
        changePass: 'user-password'
    },
    // Manage API
    user: {
        index: 'user',
        detail: 'user/:id',
        user: 'user-info',
        functions: 'user-functions',
        audit: 'audit',
        requestConfirmPhone: 'user-confirm-request',
        confirmPhone: 'user-confirm'
    },
    group: {
        index: 'group',
        detail: 'group/:id',
        user: 'user'
    },
    news: {
        index: 'news',
        detail: 'news/:id',
        files: 'files',
        analyze: 'view-statistic',
        view: 'view',
        document: 'document',
        documentById: 'document/:id'
    },
    sms: {
        user: 'sms-user',
        userDetail: 'sms-user/:id',
        history: 'sms-history',
        template: 'sms-template',
        templateDetail: 'sms-template/:id'
    },
    feedback: {
        index: 'feedback',
        detail: 'feedback/:id'
    },

    // Database API
    configuration: {
        index: 'system-parameter',
        detail: 'system-parameter/:id'
    },
    category: {
        index: 'system-category',
        detail: 'system-category/:id'
    },
    station: {
        index: 'station',
        detail: 'station/:id',
        water: 'water'
    },
    layer: {
        index: 'data-layer',
        detail: 'data-layer/:id'
    },

    // Water API
    geojson: {
        index: 'geojson',
        detail: 'geojson/:id'
    },

    // Analyze API
    analyze: {
        rain: 'report-rain',
        water: 'report-water',
        damage: 'damage',
        damageId: 'damage/:id',
        flood: 'flood',
        floodId: 'flood/:id'
    }
};

export default API_CONFIG;
